import { SlingoHTMLHelp } from "@lib/titan2-slingo/dist/game/view/abstract/display/SlingoHTMLHelp";
import { AppData } from "@lib/titan2/dist/game/AppData";
import { LanguageManager } from "@lib/titan2/dist/game/manager/LanguageManager";
/**
 * HTMLHelp.ts
 */
export class HTMLHelp extends SlingoHTMLHelp {
    createParams() {
        super.createParams();
        this.params.setValue("{param.game}", this.model.getRoomName());
    }
    addImages() {
        this.addColumn("help.slingo.standard.main.main", [this.createImage("Game-Logo.png")], "20em");
        this.addColumn("help.slingo.standard.board.title", [this.createImage("WinLines.png")], "10em");
        this.addColumn("help.slingo.standard.wild.title", [this.createImage("Game-ReelSymbolWild.png")], "10em", "10em");
        this.addColumn("help.slingo.standard.bonusspin.title", [this.createImage("Game-ReelSymbolFreeSpins.png")], "10em", "10em");
        this.addColumn("help.slingo.standard.superwild.title", [this.createImage("Game-ReelSymbolSuperWild.png")], "10em", "10em");
        this.addColumn("help.slingo.standard.scatter.title", [this.createImage("Game-ReelSymbolScatter.png")], "10em", "10em");
    }
    addCustomHTML() {
        this.createTable("help.fruityfortune.pays.title", "help.fruityfortune.line.wins", []);
        this.createTable("help.fruityfortune.max.min.title", "help.fruityfortune.max.min", []);
        if (this.isValidSwissLocale()) {
            this.createTable("help.slingo.standard.controls.line6_controls", "help.slingo.standard.swiss", []);
        }
    }
    createTable(insertAfterKey, dataKeyPrefix, imageData) {
        const tableKeys = this.language.getKeys().filter(key => key.startsWith(`${dataKeyPrefix}.col`));
        const table = document.createElement("table");
        table.className = "help-table";
        const columns = new Set();
        const rows = new Set();
        for (const key of tableKeys) {
            const match = key.matchAll(/col(\d).+row(\d)/g).next();
            const column = match.value[1];
            const row = match.value[2];
            rows.add(row);
            columns.add(column);
        }
        if (!columns.has("1")) {
            columns.add("1");
        }
        if (!rows.has("1")) {
            rows.add("1");
        }
        const rowsArray = Array.from(rows);
        rowsArray.sort((a, b) => parseInt(a) - parseInt(b));
        const columnsArray = Array.from(columns);
        columnsArray.sort((a, b) => parseInt(a) - parseInt(b));
        rowsArray.map(row => {
            const tr = document.createElement("tr");
            const tds = columnsArray.map(column => {
                const td = document.createElement("td");
                td.id = `${dataKeyPrefix}.col${column}.row${row}.cell`;
                if (this.language.containsKey(`${dataKeyPrefix}.col${column}.row${row}`)) {
                    const span = document.createElement("span");
                    span.id = `${dataKeyPrefix}.col${column}.row${row}`;
                    span.innerHTML = this.language.getValue(`${dataKeyPrefix}.col${column}.row${row}`);
                    span.className = "help-span";
                    td.append(span);
                }
                return td;
            });
            tr.append(...tds);
            table.append(tr);
        });
        this.replaceTableElementsWithImages(table, imageData);
        this.addCustomHTMLSnippet(insertAfterKey, table.outerHTML);
    }
    replaceTableElementsWithImages(table, imageData) {
        const path = AppData.VERSION + "/help/help-assets/";
        imageData.forEach(({ img, key, maxWidth, maxHeight }) => {
            const imgElement = document.createElement("img");
            imgElement.src = `${path}${img.src}`;
            imgElement.id = `${key}.img`;
            this.applyMax(imgElement, maxWidth, maxHeight);
            const target = table.querySelector(`#${CSS.escape(key)}`);
            target.id = `${key}*`; // change the key to something not in the lang files or it will get replaced with the lang text.
            target.innerHTML = "";
            target.append(imgElement);
        });
    }
    isValidSwissLocale() {
        const locale = LanguageManager.getInstance().getLocale().getId();
        const swissLocales = ["en-CH", "de-CH", "fr-CH", "it-CH"];
        return swissLocales.includes(locale);
    }
}
//# sourceMappingURL=HTMLHelp.js.map